const OTHER_GROUP_KEY = "#";

function relationshipName(customer) {
  return String(customer?.name || customer?.company || "").trim();
}

export function relationshipAlphabetKey(customer) {
  const name = relationshipName(customer);
  if (!name) return OTHER_GROUP_KEY;

  const normalized = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const initial = normalized.charAt(0).toUpperCase();
  return /^[A-Z]$/.test(initial) ? initial : OTHER_GROUP_KEY;
}

export function groupCustomersAlphabetically(customers = [], direction = "asc") {
  const collator = new Intl.Collator("en", { sensitivity: "base", numeric: true });
  const multiplier = direction === "desc" ? -1 : 1;
  const sorted = [...customers].sort((left, right) => {
    const leftGroup = relationshipAlphabetKey(left);
    const rightGroup = relationshipAlphabetKey(right);
    const leftRank = leftGroup === OTHER_GROUP_KEY ? 26 : leftGroup.charCodeAt(0) - 65;
    const rightRank = rightGroup === OTHER_GROUP_KEY ? 26 : rightGroup.charCodeAt(0) - 65;
    if (leftRank !== rightRank) {
      if (leftGroup === OTHER_GROUP_KEY) return 1;
      if (rightGroup === OTHER_GROUP_KEY) return -1;
      return (leftRank - rightRank) * multiplier;
    }

    const nameComparison = collator.compare(relationshipName(left), relationshipName(right)) * multiplier;
    if (nameComparison !== 0) return nameComparison;
    return collator.compare(String(left?.key || ""), String(right?.key || "")) * multiplier;
  });

  const groups = [];
  sorted.forEach((customer, index) => {
    const key = relationshipAlphabetKey(customer);
    const previous = groups[groups.length - 1];

    if (!previous || previous.key !== key) {
      groups.push({ key, label: key, items: [] });
    }

    groups[groups.length - 1].items.push({ customer, index });
  });

  return groups;
}
